import { useState, useEffect } from "react";
import { Spin, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

import PWAFooter from "components/footer/pwa";
import PWAJobCard from "components/job-card/pwa";
import SPAJobCard from "components/job-card/spa";

import Logo from "images/logo.png";

const Component = ({ categories, cities, specialJobsQuantity, user }) => {
	const initialState = { banners: [], jobs: [] };
	const [state, setState] = useState(initialState);
	const { banners, jobs, loaded } = state;

	const componentDidUpdate = () => {
		if (typeof cities === "string") {
			setState((prevState) => ({
				...prevState,
				loaded: false,
			}));

			Promise.all([
				API.banner.list({
					category: "null",
					cities,
					paginate: false,
				}),
				API.job.special({
					cities,
				}),
			])
				.then(([{ data: banners }, { data: jobs }]) => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
						banners,
						jobs,
					}));
				})
				.catch();
		}
	};

	useEffect(componentDidUpdate, [cities]);

	return loaded ? (
		<>
			<div className="page-index">
				<MediaQuery maxWidth={992}>
					<div className="navbar">
						<div className="container">
							<Link
								to={`#${Modals.LOCATION}`}
								className="locate"
							>
								<Icons.Location />
							</Link>
							<Link
								to="/"
								className="logo"
							>
								<img
									src={Logo}
									alt={Resources.bakelid}
								/>
							</Link>

							<Link
								to={`/panel/notifications`}
								className="notif"
							>
								{user?.unreadNotificationsCount > 0 ? (
									<span className="badge">
										{user?.unreadNotificationsCount}
									</span>
								) : (
									""
								)}
								<Icons.Notification />
							</Link>
						</div>
					</div>
					<div className="location">
						<div className="container">
							<div className="wrap">
								<Link
									to={`#${Modals.LOCATION}`}
									className="province"
								>
									{Resources.province}
								</Link>
								<Link
									to={`#${Modals.LOCATION}`}
									className="city"
								>
									{Resources.city}
								</Link>
							</div>
						</div>
					</div>
				</MediaQuery>
				{!!banners.length && (
					<div className="banners">
						<div className="container">
							<Swiper
								autoplay={{ delay: 3000 }}
								pagination={{ el: ".swiper-pagination", clickable: true }}
								breakpoints={{
									992: {
										slidesPerView: 2,
										spaceBetween: 24,
									},
								}}
								resistanceRatio={0}
								modules={[Autoplay, Pagination]}
							>
								{banners.map((o) => (
									<SwiperSlide key={o.id}>
										<Link to="#">
											<img
												src={o.cover}
												alt={o.title}
											/>
										</Link>
									</SwiperSlide>
								))}
							</Swiper>
							<div className="swiper-pagination"></div>
						</div>
					</div>
				)}
				<div className="categories">
					<div className="container">
						<span className="heading">{Resources.category}</span>
						<div className="list">
							<ul className="row">
								{categories
									.filter((o) => !o.parentId)
									.map((o) => (
										<li
											className="col-md-2 col-sm-3 col-4"
											key={o.id}
										>
											<Tooltip title={o.title}>
												<Link to={`#${Modals.CATEGORY}_${o.id}`}>
													<img
														src={o.icon}
														alt={o.title}
													/>
													{o.title}
												</Link>
											</Tooltip>
										</li>
									))}
							</ul>
						</div>
					</div>
				</div>
				<div className="jobs">
					<div className="container">
						<span className="heading">
							{`${Resources.jobs} ${Resources.special}`}
						</span>
						<div className="list">
							<ul className="row">
								{jobs.map((o) => (
									<li
										key={o.id}
										className="col-12 col-md-6 col-lg-4 col-xl-3"
									>
										<MediaQuery maxWidth={992}>
											<PWAJobCard {...o} />
										</MediaQuery>
										<MediaQuery minWidth={992}>
											<SPAJobCard {...o} />
										</MediaQuery>
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<MediaQuery maxWidth={992}>
				<PWAFooter active="home" />
			</MediaQuery>
		</>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect((state) => {
	return {
		categories: state.categories || [],
		cities: state.configs?.cities?.map((o) => o.id).join() || [],
		specialJobsQuantity: state.settings.specialJobsQuantity,
		user: state.user,
	};
})(Component);
